export const DOCUMENT_OPEN = 'DOCUMENT_OPEN';
export const DOCUMENT_OPEN_COMPLETED = 'DOCUMENT_OPEN_COMPLETED';
export const DOCUMENT_OPEN_FAILED = 'DOCUMENT_OPEN_FAILED';
export const DOCUMENT_CLOSE = 'DOCUMENT_CLOSE';
export const DOCUMENT_RENAME = 'DOCUMENT_RENAME';
export const DOCUMENT_RESET_TO_OPEN_VERSION = 'DOCUMENT_RESET_TO_OPEN_VERSION';
export const DOCUMENT_REVERT = 'DOCUMENT_REVERT';
export const DOCUMENT_SAVE = 'DOCUMENT_SAVE';
export const DOCUMENT_SAVE_COMPLETED = 'DOCUMENT_SAVE_COMPLETED';
export const DOCUMENT_SAVE_FAILED = 'DOCUMENT_SAVE_FAILED';
export const DOCUMENT_LOAD_VERSION = 'DOCUMENT_LOAD_VERSION';
export const DOCUMENT_LOAD_VERSION_COMPLETED = 'DOCUMENT_LOAD_VERSION_COMPLETED';
export const DOCUMENT_LOAD_VERSION_FAILED = 'DOCUMENT_LOAD_VERSION_FAILED';
export const DOCUMENT_FETCH_VERSIONS = 'DOCUMENT_FETCH_VERSIONS';
export const DOCUMENT_FETCH_VERSIONS_COMPLETED = 'DOCUMENT_FETCH_VERSIONS_COMPLETED';
export const DOCUMENT_FETCH_VERSIONS_FAILED = 'DOCUMENT_FETCH_VERSIONS_FAILED';
export const DOCUMENT_REGISTER_OBJECTS = 'DOCUMENT_REGISTER_OBJECTS';
export const DOCUMENT_UPDATE = 'DOCUMENT_UPDATE';
export const DOCUMENT_INVALIDATE = 'DOCUMENT_INVALIDATE';
export const DOCUMENT_SERVER_SIDE_UPDATE = 'DOCUMENT_SERVER_SIDE_UPDATE';
